// extracted by mini-css-extract-plugin
export var filterIncDec = "_9o-0";
export var leftBorder = "_9o-1";
export var rightBorder = "_9o-2";
export var stringInput = "_9o-3";